
import {gql, useQuery, WatchQueryFetchPolicy} from '@apollo/client';

interface Result {
	auth: {
		user?: {
			id: string

			details: {
				email: string
				firstName: string
				isProvisional: boolean
			}

			permissions: {
				all: string[]
			}
		}
	}
}

const getAuth = gql`
query {
    auth {
		id
        user {
			id

			details {
				id
				email
				firstName
				isProvisional
			}

			permissions {
				all
			}
        }
    }
}`;

export const useAuth = (fetchPolicy: WatchQueryFetchPolicy) => {
	return useQuery<Result>(getAuth, {fetchPolicy});
};
